import {
    createRouter,
    createWebHistory
} from 'vue-router'
import store from '../store';
const router = createRouter({
    routes: [{
            path: '/',
            component: () =>
                import ('../pages/Auth/Login.vue'),
            meta: {
                guest: true,
            },
            name: 'login',
        }, {
            path: '/registration',
            component: () =>
                import ('../pages/Auth/Registration.vue'),
            meta: {
                requiresAuth: true,
            },
            name: 'registration',
        },
        /**
         * Privacy Policy & Terms
         */
        {
            path: '/guest/privacy/policy',
            component: () =>
                import ('../pages/Policy/PrivacyPolicy.vue'),
            meta: {
                guest: true,

            },
            name: 'guest.privacy.policy',
        },
        {
            path: '/guest/terms',
            component: () =>
                import ('../pages/Policy/Terms.vue'),
            meta: {
                guest: true,

            },
            name: 'guest.terms',
        },
        {
            path: '/sc/subscribe',
            component: () =>
                import ('../pages/SMS/callToSMS.vue'),
            meta: {
                both: true,

            },
            name: 'guest.sc.subscribe',
        },


        // Login Pages
        {
            path: '/home',
            component: () =>
                import ('../pages/layouts/HomeLayout.vue'),
            meta: {
                requiresAuth: true,
            },
            children: [{
                    path: '',
                    component: () =>
                        import ('../pages/Home.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'home'
                    },
                    name: 'home',
                }, {
                    path: '/news',
                    component: () =>
                        import ('../pages/News/news.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'news'
                    },
                    name: 'home.news',
                }, {
                    path: '/news/details/:id',
                    component: () =>
                        import ('../pages/News/NewsDetails.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'news'
                    },
                    name: 'home.news.details',
                }, {
                    path: '/events/list',
                    component: () =>
                        import ('../pages/GameActivity/GameActivityList.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'gameActivity'
                    },
                    name: 'home.events.list',
                },
                {
                    path: '/events/:id',
                    component: () =>
                        import ('../pages/GameActivity/GameActivityDetailsNew.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'gameActivity'
                    },
                    name: 'home.event.details',
                },
                {
                    path: '/game/activity/:id',
                    component: () =>
                        import ('../pages/GameActivity/GameActivityDetails.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'gameActivity'
                    },
                    name: 'home.game.activity.details',
                }, {
                    path: '/stories',
                    component: () =>
                        import ('../pages/Stories/stories.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'stories'
                    },
                    name: 'home.stories',
                }, {
                    path: '/story/details/:id',
                    component: () =>
                        import ('../pages/Stories/StoryDetails.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'stories'
                    },
                    name: 'home.story.details',
                }, {
                    path: '/contact',
                    component: () =>
                        import ('../pages/contactUs.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'profile'
                    },
                    name: 'home.contactUs',
                }, {
                    path: '/single-blog',
                    component: () =>
                        import ('../pages/single-blog.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                    name: 'home.single-blog',
                },
                {
                    path: '/trailers',
                    component: () =>
                        import ('../pages/trailers.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'trailers'
                    },
                    name: 'home.trailers',
                },
                /**
                 * Games community
                 */
                {
                    path: '/community/list',
                    component: () =>
                        import ('../pages/Community/CommunityList.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'community'
                    },
                    name: 'home.community.list',
                },
                {
                    path: '/giveaways',
                    component: () =>
                        import ('../pages/Giveaways/index.vue'),
                    meta: {
                        requiresAuth: true,
                        // nav: 'profile'
                        nav: 'giveaways'
                    },
                    name: 'home.giveaways',
                },
                {
                    path: '/my/posts',
                    component: () =>
                        import ('../pages/Community/CommunityList.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'profile'
                    },
                    name: 'home.my.posts',
                },
                {
                    path: '/community/form',
                    component: () =>
                        import ('../pages/Community/CommunityForm.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'community'
                    },
                    name: 'home.community.form',
                },
                {
                    path: '/community/edit/:id',
                    component: () =>
                        import ('../pages/Community/CommunityForm.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'community'
                    },
                    name: 'home.community.edit',
                },
                {
                    path: '/community/details/:id',
                    component: () =>
                        import ('../pages/Community/CommunityDetails.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'community'
                    },
                    name: 'home.community.details',
                },
                /**
                 * Profile
                 */
                {
                    path: '/profile',
                    component: () =>
                        import ('../pages/myProfile/profile.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'profile'
                    },
                    name: 'home.profile',
                },
                {
                    path: '/profile/form',
                    component: () =>
                        import ('../pages/myProfile/profileFrom.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'profile'
                    },
                    name: 'home.profile.form',
                },
                /**
                 * Privacy Policy & Terms
                 */
                {
                    path: '/privacy/policy',
                    component: () =>
                        import ('../pages/Policy/PrivacyPolicy.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'profile'
                    },
                    name: 'home.privacy.policy',
                },
                {
                    path: '/terms',
                    component: () =>
                        import ('../pages/Policy/Terms.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'profile'
                    },
                    name: 'home.terms',
                },
                {
                    path: '/my/comments',
                    component: () =>
                        import ('../pages/myProfile/myComments.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'profile'
                    },
                    name: 'home.my.comments',
                },
                {
                    path: '/my/likes',
                    component: () =>
                        import ('../pages/myProfile/myLikes.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'profile'
                    },
                    name: 'home.my.likes',
                },
                {
                    path: '/game/list/new',
                    component: () =>
                        // import ('../pages/lastGames/gamesList.vue'),
                        import ('../pages/lastGames/gamesListRemoteNew.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'games'
                    },
                    name: 'home.game.list1',
                },

                /**
                 * Game List
                 */
                {
                    path: '/game/list',
                    component: () =>
                        // import ('../pages/lastGames/gamesList.vue'),
                        import ('../pages/lastGames/gamesListRemoteNew.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'games'
                    },
                    name: 'home.game.list',
                },
                {
                    path: '/game/details/:id',
                    component: () =>
                        // import ('../pages/lastGames/gameDetails.vue'),
                        import ('../pages/lastGames/gameDetailsRemote.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'games'
                    },
                    name: 'home.game.details',
                },
                {
                    path: '/game/source/list',
                    component: () =>
                        import ('../pages/lastGames/gamesListRemote.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'games'
                    },
                    name: 'home.game.list.remote',
                },
                {
                    path: '/game/details/source/:id',
                    component: () =>
                        import ('../pages/lastGames/gameDetailsRemote.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'games'
                    },
                    name: 'home.game.details.remote',
                },
                {
                    path: '/game/check/performance/:id',
                    component: () =>
                        import ('../pages/lastGames/CheckGamePerformance.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'games'
                    },
                    name: 'home.game.details.remote.check.performance',
                },


                {
                    path: '/competitive/games',
                    name: 'CompetitiveGames',
                    component: () =>
                        import ('../pages/CompetitiveGames/Index.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'competitiveGames'
                    },
                },

                {
                    path: '/competitive/games/chess',
                    component: () =>
                        import ('../pages/CompetitiveGames/Chess/MatchPage.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'competitiveGames'
                    },
                    name: 'home.competitive.games.chess',
                },


                {
                    path: '/cheese',
                    name: 'home.games.cheese',
                    component: () =>
                        import ('../pages/CompetitiveGames/Chess/HomePage.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'competitiveGames'
                    },
                },
                {
                    path: '/matchmaking',
                    name: 'Matchmaking',
                    component: () =>
                        import ('../pages/CompetitiveGames/Chess/MatchmakingPage.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'competitiveGames'
                    },
                },
                {
                    path: '/match/:id',
                    name: 'Match',
                    component: () =>
                        import ('../pages/CompetitiveGames/Chess/MatchPage.vue'),
                    meta: {
                        requiresAuth: true,
                        nav: 'competitiveGames'
                    },
                    props: true
                }


            ]
        },
    ],
    history: createWebHistory(),
});


router.beforeEach((to, from, next) => {
    store.commit('admin/cleanGlobalSearch', []);
    // --- الجزء المضاف لمعالجة التوكن من الـ Hash ---
    const hash = window.location.hash;
    if (hash && hash.includes('token=')) {
        const token = hash.split('token=')[1];
        if (token) {
            // 1. التخزين في الـ LocalStorage (للمرات القادمة)
            localStorage.setItem('client/user-token', token);

            // 2. 🚀 تحديث الـ Store فوراً (عشان الـ Axios Interceptor يشوفه حالاً)
            // تأكد من اسم الـ mutation الصحيح عندك في مديول الـ admin
            store.commit('admin/setAuthToken', token);

            // 3. تنظيف الرابط
            window.history.replaceState(null, null, window.location.pathname + window.location.search)
        }
    }
    // ----------------------------------------------

    let userToken = localStorage.getItem('client/user-token');

    if (to.matched.some(record => record.meta.requiresAuth)) {
        let name = 'login';

        if (userToken === null) {
            next({
                name: name,
                params: { nextUrl: to.fullPath }
            });
        } else {
            next();
        }
    } else if (to.matched.some(record => record.meta.guest)) {

        if (userToken == null) {
            next();
        } else {
            next({ name: 'home' });
        }
    } else {
        next();
    }
});




export default router